<template>
  <div>
    <div class="container-fluid">
      <div class="row justify-content-around align-items-center">
        <div class="col-md-6">
          <vs-card class="img pt-5 pb-5 pl-5 pr-5">
            <div class="container-fluid">
              <div class="row justify-content-around align-items-center">
                <div class="col-md-10">
                  <h6>{{$t('selectCategory')}}</h6>
                  <v-select
                    v-validate="'required'"
                    taggable
                    class="mt-5"
                    :placeholder="$t('selectCategory')"
                    label="categoryName"
                    :name="$t('selectCategory')"
                    :closeOnSelect="true"
                    v-model="sendData.CategoryId"
                    :options="categories"
                    :reduce="categoryName => categoryName.id"
                    @input="step2"
                  />
                  <span class="text-danger text-sm">{{ errors.first($t('selectCategory')) }}</span>
                </div>
              </div>
              <div
                class="row justify-content-around align-items-center"
                style="margin-top:30px"
                v-if="properties.length > 0"
              >
                <div class="col-md-12">
                  <vs-table class="img" stripe :data="properties">
                    <template slot="thead">
                      <vs-th class="colors">{{$t("featureName")}}</vs-th>
                      <vs-th class="colors">{{$t("value")}}</vs-th>
                    </template>
                    <template slot-scope="{data}">
                      <vs-tr :key="indextr" v-for="(item, indextr) in data">
                        <vs-td :data="item.propertyName">{{ item.propertyName }}</vs-td>
                        <vs-td :data="item.value">
                          <vs-input :label-placeholder="$t('value')" v-model="item.value" />
                        </vs-td>
                      </vs-tr>
                    </template>
                  </vs-table>
                </div>
              </div>
            </div>
          </vs-card>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: ["categories", "sendData", "properties"],
  methods: {
    step2() {
      this.$emit("step2");
    },
  },
};
</script>

<style>
</style>